sn-banner-type-1 {
  .me-container {
    padding-top: 0;
    padding-bottom: 0;
  }
}
